import { ApplyTo, PricingFormula, PricingSheetMeta, Status } from './constants';

export function getPricingSheetStatus(pricingSheet: PricingSheetMeta): Status {
  if (pricingSheet.draft) {
    return 'Draft';
  }
  if (pricingSheet.expiryDate) {
    if (new Date(pricingSheet.expiryDate) < new Date()) {
      return 'Expired';
    }
  }
  if (pricingSheet.startDate) {
    if (new Date(pricingSheet.startDate) > new Date()) {
      return 'Inactive';
    }
  }
  return pricingSheet.enabled ? 'Active' : 'Inactive';
}

export function getPricingSheetApplyTo(pricingSheet: PricingSheetMeta): ApplyTo {
  const hasGroups = (pricingSheet.customerGroups?.length ?? 0) > 0;
  const hasIndividuals = (pricingSheet.individualCustomers?.length ?? 0) > 0;
  if (hasGroups && hasIndividuals) {
    return 'Customer groups & individuals';
  }
  if (hasGroups) {
    return 'Specific customer groups';
  }
  if (hasIndividuals) {
    return 'Specific individuals';
  }
  return 'All customers';
}

// All monetary inputs and output are INTs representing cents
export function calculateMarginAndPrice(
  costBasis: number | null | undefined,
  pricingFormula: PricingFormula | null | undefined,
  pricingValue?: number | null,
  roundingValue?: number | null
) {
  const margin =
    pricingFormula === 'COST_BASIS_PERCENT_MARGIN' ? Number(costBasis) * (Number(pricingValue) / 100) : pricingValue;
  let total = Math.round(Number(costBasis) + Number(margin));

  if (roundingValue) {
    total = Math.round(total / roundingValue) * roundingValue;
  }

  return { margin, total };
}
